import { Reveal, Chapter } from "./Reveal";

const STEPS = [
  { n: "1", title: "Choose Your Products", body: "Select the Revora stands, plates or cards your business needs." },
  { n: "2", title: "Provide Your Review Link", body: "Enter the Google review URL where customers should be directed." },
  { n: "3", title: "We Configure Your Products", body: "Each product receives its unique Revora identity, routed to your review page." },
  { n: "4", title: "Quality Check", body: "The order is checked before shipment." },
  { n: "5", title: "Ships to Your Business", body: "Your Revora products arrive ready to use." },
  { n: "6", title: "Place & Tap", body: "Put them where customers interact with your business. One tap reaches your review page." },
];

export const ProcessTimeline = () => (
  <section className="bg-white py-28 sm:py-36" data-testid="process-section">
    <div className="max-w-7xl mx-auto px-6">
      <Chapter number="08" label="Order Process" />
      <Reveal>
        <h2 className="rvr-title font-display text-4xl md:text-5xl font-bold tracking-tight text-ink leading-[1.05]">
          Order <span className="text-volt">→</span> Customize <span className="text-volt">→</span> Program <span className="text-volt">→</span> Receive
        </h2>
      </Reveal>
      <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-x-4 gap-y-12">
        {STEPS.map((s, i) => (
          <Reveal key={s.n} delay={i * 0.07}>
            <div className="relative pt-8 border-t-2 border-ink group" data-testid={`process-step-${s.n}`}>
              <span className="absolute -top-[13px] left-0 w-6 h-6 rounded-full bg-white border-2 border-ink group-hover:bg-volt group-hover:border-volt transition-colors duration-300" />
              <p className="font-display text-6xl font-black text-black/[0.07] leading-none mb-3">{s.n}</p>
              <p className="font-display text-lg font-bold text-ink">{s.title}</p>
              <p className="text-sm text-black/55 mt-1.5 leading-relaxed">{s.body}</p>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
